import { FC } from "react";
import { getTextFromTranslations } from "@/helpers/translation";
import styles from "./ReceiptRow.module.scss";
import { formatMoney } from "@/helpers/numbers";
import Translations from "@/types/translations";

interface ReceiptRowProps {
  translations?: Translations[];
  fallbackTitle?: string;
  quantity?: number;
  priceCents?: number;
}

const ReceiptRow: FC<ReceiptRowProps> = ({
  translations,
  fallbackTitle,
  quantity = 1,
  priceCents = 0,
}) => {
  const name = getTextFromTranslations(translations)?.name ?? fallbackTitle;
  const description = getTextFromTranslations(translations)?.description ?? undefined;

  return (
    <div className={styles.container}>
      <b>{quantity}x</b>
      <div className={styles.textWrapper}>
        <p className={styles.productName} data-cy="receipt-row-name">
          {name}
        </p>
        {description && <span className={styles.subText}>{description}</span>}
      </div>
      <b>{formatMoney((priceCents * quantity) / 100)}</b>
    </div>
  );
};

export default ReceiptRow;
